import * as React from 'react';
import * as styles from './styles.css';
import { WorkHonestly } from '../../../WorkHonestly';
import { AgentType, RgrCertificate } from '../../../RgrCertificate';
import { UIText2 } from '@cian/ui-kit';

interface IRealtorCardProps {
  previewImg: React.ReactNode;
  hasRgrParticipation: boolean;
  name: string;
  levelName?: string | null;
  levelNumber?: number | null;
  agencyName?: string | null;
  timeOnSite?: string | null;
}

export const RealtorCard: React.FC<React.PropsWithChildren<IRealtorCardProps>> = ({
  name,
  levelName,
  levelNumber,
  hasRgrParticipation,
  agencyName,
  timeOnSite,
  previewImg,
}) => {
  return (
    <div className={styles['card']}>
      <div className={styles['img']}>{previewImg}</div>
      <div className={styles['name']}>
        <span>{name}</span>
        <WorkHonestly levelNumber={levelNumber} levelName={levelName} />

        {hasRgrParticipation && <RgrCertificate type={AgentType.Realtor} />}
      </div>
      <UIText2 color="black_60">{agencyName}</UIText2>
      <UIText2 color="black_60">{timeOnSite}</UIText2>
    </div>
  );
};

RealtorCard.displayName = 'RealtorCard';
